var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "text-n-gray-dark" },
    [
      _c("RegisterPageHeader"),
      _vm._v(" "),
      _c(
        "main",
        {
          staticClass: "max-w-2xl m-auto py-4 md:py-16 px-5",
          attrs: { id: "main" },
        },
        [
          _c("div", { staticClass: "flex flex-col md:flex-row" }, [
            _c(
              "div",
              { staticClass: "md:mx-5 flex-no-shrink block w-full md:w-215px" },
              [
                _c("RegisterPageSteps"),
                _vm._v(" "),
                !_vm.isLoggedIn
                  ? _c("div", { staticClass: "hidden md:block" }, [
                      _c("hr", {
                        staticClass:
                          "w-px bg-n-gray border border-n-gray w-full my-10",
                      }),
                      _vm._v(" "),
                      _c(
                        "p",
                        [
                          _vm._v("\n            Already have an account? "),
                          _c(
                            "router-link",
                            { attrs: { to: { name: "user-login" } } },
                            [_vm._v("Log In.")]
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex-shrink md:mx-20" },
              [
                _vm._t("default"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-center text-lg font-sans-book" },
                  [
                    _vm._v(
                      "\n          Questions or feedback? We'd love to hear from you.\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm._m(0),
              ],
              2
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-center text-lg font-sans-book" }, [
      _vm._v("\n          Email us at "),
      _c("a", { attrs: { href: "mailto:hello@letsreimagine.org" } }, [
        _vm._v("hello@letsreimagine.org"),
      ]),
      _vm._v(".\n        "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }